import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';
import './styles.scss';

class ReduxFormCheckbox extends Component {
    static defaultProps = {
        tabIndex: 0,
    }

    static propTypes = {
        input: PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.bool.isRequired,
            onChange: PropTypes.func.isRequired,
        }).isRequired,
        className: PropTypes.string.isRequired,
        iconType: PropTypes.string.isRequired,
        iconSize: PropTypes.string.isRequired,
        tabIndex: PropTypes.number,
    }

    constructor(props) {
        super(props);
        this.onCheckChanged = this.onCheckChanged.bind(this);
    }

    onCheckChanged() {
        const { onChange, value } = this.props.input;
        onChange(!value);
    }

    render() {
        const {
            input: { name, value },
            className,
            iconType,
            iconSize,
            tabIndex,
        } = this.props;

        return (
            <Checkbox
                name={name}
                checked={value}
                onSelect={this.onCheckChanged}
                className={className}
                iconType={iconType}
                iconSize={iconSize}
                tabIndex={tabIndex}
            />
        );
    }
}

export default ReduxFormCheckbox;



// WEBPACK FOOTER //
// /src/js/common/checkbox/ReduxFormCheckbox.jsx